import { dateFormatter } from '../../../utils/functions';
import { AssociateType } from '../../Associate/enum';
import {
    AssociateRateShipmentHistoryTitles,
    BrokerShipmentHistoryTitles,
    CustomerShipmentHistoryTitles,
    DriverShipmentHistoryTitles,
} from '../constants';

export interface IShipmentHistoryUtils {
    shipmentHistoryFilterQuery: (
        associateId: string | number,
        associateType: AssociateType,
        deliveryStartDate?: string,
        deliveryEndDate?: string,
    ) => string;
    shipmentHistoryTitles: (
        associateType: AssociateType,
        invoiceSubscription: boolean,
    ) => string[];
}

export class ShipmentHistoryUtils implements IShipmentHistoryUtils {
    shipmentHistoryFilterQuery = (
        associateId: string | number,
        associateType: AssociateType,
        deliveryStartDate?: string | Date,
        deliveryEndDate?: string | Date,
    ): string => {
        let query = '$orderby=DeliveryStartDate desc';
        let includeQuery = `&include=Associate,ShipmentLocations.Location,ShipmentCargoDetails.Commodity,ShipmentStatus,Associate`;
        let filterCondition = 'IsActive eq true';

        if (associateType === AssociateType.Driver) {
            includeQuery += ',DriverLoads.DriverLoadCargoDetails.Commodity';
            filterCondition += ` and (DriverLoads/any(d: d/AssociateId eq ${associateId} and d/DeliveredDateTime ne null))`;
        } else if (associateType === AssociateType.Customer) {
            filterCondition += ` and ((AssociateId eq ${associateId}) and (ShipmentStatus/Name ne 'ContinueBuilding'))`;
        } else if (associateType === AssociateType.Broker) {
            filterCondition += ` and ((AssociateId eq ${associateId}) or (DriverLoads/any(d: d/AssociateId eq ${associateId})))`;
        }

        if (deliveryStartDate) {
            filterCondition += ` and (DeliveryStartDate ge ${dateFormatter(
                deliveryStartDate,
            )})`;
        }
        if (deliveryEndDate) {
            filterCondition += ` and (DeliveryStartDate le ${dateFormatter(
                deliveryEndDate,
            )})`;
        }

        query += `&$filter=${filterCondition}`;

        return query + includeQuery;
    };

    shipmentHistoryTitles = (
        associateType: AssociateType,
        invoiceSubscription: boolean,
    ): string[] => {
        if (associateType === AssociateType.Broker) {
            return invoiceSubscription
                ? [
                      ...BrokerShipmentHistoryTitles,
                      ...AssociateRateShipmentHistoryTitles,
                  ]
                : BrokerShipmentHistoryTitles;
        } else if (associateType === AssociateType.Customer) {
            return invoiceSubscription
                ? [
                      ...CustomerShipmentHistoryTitles,
                      ...AssociateRateShipmentHistoryTitles,
                  ]
                : CustomerShipmentHistoryTitles;
        } else {
            return invoiceSubscription
                ? [
                      ...DriverShipmentHistoryTitles,
                      ...AssociateRateShipmentHistoryTitles,
                  ]
                : DriverShipmentHistoryTitles;
        }
    };
}
